import React from "react";
import "../assets/css/footer.css";
import nav_logo from "../assets/images/lg_white.png";
import { Link } from "react-router-dom";

import { FaFacebook, FaTwitter, FaYoutube, FaInstagram } from "react-icons/fa";

const Footer = () => {
  const currentDate = new Date().getFullYear();

  return (
    <>
      <div className="footer">
        <div className="footer-content">
          <div className="footer-row">
            <div className="footer-col">
              <img className="logo" src={nav_logo} alt="nav logo" />
              <p>Pioneering Tech For a Smarter Tomorrow.</p>
            </div>
            <div className="footer-links">
              <div className="footer-col">
                <span>
                  <Link to="/contact">contact</Link>
                </span>
              </div>
              <div className="footer-col">
                <span>
                  <Link to="/faq">FAQ</Link>
                </span>
              </div>
              <div className="footer-col">
                <span>
                  <Link to="/termsandconditions">terms and condition</Link>
                </span>
              </div>
            </div>
          </div>
          <div className="footer-row">
            <p>
              © Copyright {currentDate} {"  "}
              <a href="https://www.nexatrux.com/">nexatrux.com</a>
            </p>
            <div className="footer-socials">
              <a
                href="https://web.facebook.com/nexatrux/"
                target="_blank"
                rel=" noreferrer"
              >
                <FaFacebook />
              </a>
              <a
                href="https://x.com/NexaTrux"
                target="_blank"
                rel=" noreferrer"
              >
                <FaTwitter />
              </a>
              <a
                href="https://www.youtube.com/@nexatrux"
                target="_blank"
                rel=" noreferrer"
              >
                <FaYoutube />
              </a>
              <a
                href="https://www.instagram.com/nexatrux/"
                target="_blank"
                rel=" noreferrer"
              >
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
